module.exports = __webpack_public_path__ + "img/slide14.5d8d2cd4.png";